import React, { useRef } from "react";
import InputBoxes from "../common/InputBoxes";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";
const KS10Email = (props) => {
  const { email, setEmail } = props;
  const emailDivRef = useRef(null);
  const onTextChange = (e) => {
    const { name, value } = e.target
    const index = name.replace("email", "");
    checkChildrenAndSetFocus(emailDivRef.current.children, index);
    setEmail({ name, value });
  };
  return (
    <div className="row">
      <div className="mb-3 section-number-box col-sm-12 col-md-12 col-lg-12">
        <div className="mb-3 number">5.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label">
              <label className="">Your email address</label>
            </div>

            <div className="section-form-group">
              <div className="section-form-group-inline" ref={emailDivRef}>
                <InputBoxes keyName={"email"} name={email} count={62} onTextChange={onTextChange} />
                <small className="small-title-label d-flex">
                  <br />
                  If you give an email address you may receive KiwiSaver information by email
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10Email;
